import { motion } from "framer-motion";
import { MapPin, Users, Activity } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Icon3D } from "./Icon3D";
import { fadeUp, cardReveal } from "@/lib/animations";

const facts = [
  {
    icon: Users,
    title: "Para quem",
    desc: "Operadoras de planos de saúde e administradoras de benefícios.",
    variant: "deepBlue",
  },
  {
    icon: MapPin,
    title: "Onde atende",
    desc: "Todo o Brasil, com operação remota e sede em Vila Velha/ES.",
    variant: "vividBlue",
  },
  {
    icon: Activity,
    title: "Escala",
    desc: "Capacidade de 6.000 entrevistas por mês, com tempo médio de 15 minutos.",
    variant: "aqua",
  },
];

export const AboutPrevisa = () => (
  <section
    id="quem-somos"
    data-testid="about-section"
    className="relative py-16 md:py-24"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <SectionHeading
        overline="Quem somos"
        title="Uma healthtech dedicada à"
        highlight="saúde suplementar"
        testid="about-heading"
      />
      <motion.p
        {...fadeUp}
        className="mt-6 max-w-3xl text-lg text-[#64748B] leading-relaxed"
      >
        A Previsa Saúde é uma healthtech de Vila Velha/ES especializada em{" "}
        <a
          href="/solucoes/entrevista-medica-qualificada"
          className="text-[#3532B3] font-semibold hover:underline"
        >
          entrevista médica qualificada
        </a>{" "}
        e análise técnica de risco para a saúde suplementar. Atendemos
        operadoras e administradoras de planos de saúde em todo o Brasil, com
        operação remota e capacidade de 6.000 entrevistas por mês.
      </motion.p>

      <div className="mt-12 grid sm:grid-cols-3 gap-5 max-w-4xl">
        {facts.map((f, idx) => (
          <motion.article
            key={f.title}
            {...cardReveal(idx * 0.06, 0.5)}
            data-testid={`about-fact-${idx}`}
            className="group bg-white rounded-3xl border border-[#E5EAF2] p-7 hover:shadow-[0_20px_50px_rgba(53,50,179,0.10)] hover:border-[#3787F5]/30 transition-all duration-300"
          >
            <Icon3D
              icon={f.icon}
              variant={f.variant}
              size="md"
              className="mb-4 group-hover:scale-110 group-hover:-rotate-3"
            />
            <h3 className="text-base font-bold text-[#1F2937]">{f.title}</h3>
            <p className="mt-2 text-[15px] text-[#64748B] leading-relaxed">
              {f.desc}
            </p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
